import { openDB } from 'idb';

import { GameDocumentState } from '../../contexts/game-document';

const DB_NAME = 'catalyst-games-portal';
const STORE_NAME = 'game-document';

export const dbPromise = openDB(DB_NAME, 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains(STORE_NAME)) {
      db.createObjectStore(STORE_NAME, { keyPath: 'gameId' });
    }
  }
});

export const saveGameToDB = async (gameDoc: GameDocumentState) => {
  const db = await dbPromise;
  const sanitizedGameDoc = JSON.parse(JSON.stringify(gameDoc));
  await db.put(STORE_NAME, sanitizedGameDoc);
};

export const getGameFromDB = async (gameId: number) => {
  const db = await dbPromise;
  return db.get(STORE_NAME, gameId);
};

export const deleteGameFromDB = async (gameId: number) => {
  const db = await dbPromise;
  await db.delete(STORE_NAME, gameId);
};
